import { useRef } from "react";
import KPIQuestions from "../KPIQuestions";

export default function KPIQuestionsModal({
  open,
  kpiId,
  onClose
}) {
  const perguntasRef = useRef(null);

  if (!open || !kpiId) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100
                 d-flex align-items-center justify-content-center"
      style={{ background: "rgba(0,0,0,.5)", zIndex: 1050 }}
    >
      {/* CAIXA DO MODAL */}
      <div
        className="bg-white rounded d-flex flex-column"
        style={{ width: 800, maxHeight: "90vh" }}
      >

        {/* ===== HEADER ===== */}
        <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Perguntas do KPI</h5>
          <button className="btn-close" onClick={onClose} />
        </div>

        {/* ===== CONTEÚDO (SCROLL) ===== */}
        <div
          className="p-3"
          style={{ overflowY: "auto", flex: 1 }}
        >
          <KPIQuestions
            ref={perguntasRef}
            kpiId={kpiId}
            modoEmbed
          />
        </div>

        {/* ===== FOOTER FIXO ===== */}
        <div className="p-3 border-top d-flex justify-content-end gap-2">
          <button
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            Fechar
          </button>

          <button
            className="btn btn-success"
            onClick={() => perguntasRef.current?.salvarPergunta()}
          >
            Adicionar Pergunta
          </button>
        </div>

      </div>
    </div>
  );
}
